import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["verificationView", "editView", "emailDisplay", "otpSection", "currentEmail", "newEmailInput", "submitButton", "errorMessage"]
  static values = {
    applicationId: String,
    updateUrl: String
  }

  showEditView() {
    // Hide the email display, show the edit form
    if (this.hasEmailDisplayTarget) {
      this.emailDisplayTarget.classList.add("hidden")
    }
    this.editViewTarget.classList.remove("hidden")
    this.newEmailInputTarget.value = ""
    this.newEmailInputTarget.focus()
    this.hideError()

    // Gray out the OTP section
    if (this.hasOtpSectionTarget) {
      this.otpSectionTarget.classList.add("opacity-30", "pointer-events-none")
    }

    // Gray out the verify button (outside controller scope)
    const verifyButton = document.getElementById("verify-continue-button")
    if (verifyButton) {
      verifyButton.classList.add("opacity-30", "pointer-events-none")
    }
  }

  showVerificationView() {
    // Hide the edit form, show the email display
    this.editViewTarget.classList.add("hidden")
    if (this.hasEmailDisplayTarget) {
      this.emailDisplayTarget.classList.remove("hidden")
    }
    this.hideError()

    // Restore the OTP section
    if (this.hasOtpSectionTarget) {
      this.otpSectionTarget.classList.remove("opacity-30", "pointer-events-none")
    }

    // Restore the verify button
    const verifyButton = document.getElementById("verify-continue-button")
    if (verifyButton) {
      verifyButton.classList.remove("opacity-30", "pointer-events-none")
    }
  }

  async updateEmail(event) {
    event.preventDefault()

    const newEmail = this.newEmailInputTarget.value.trim()

    if (!newEmail || !newEmail.includes("@")) {
      this.showError("Please enter a valid email address")
      return
    }

    if (newEmail === this.currentEmailTarget.textContent.trim()) {
      this.showError("New email must be different from current email")
      return
    }

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Updating...
    `

    try {
      // Update the email
      const updateResponse = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "X-Auto-Save": "true"
        },
        body: JSON.stringify({
          loan_application: { applicant_email: newEmail }
        })
      })

      if (!updateResponse.ok) {
        const data = await updateResponse.json()
        throw new Error(data.error || "Failed to update email")
      }

      // Clear OTP resend cooldown so autoSendCode fires on reload
      sessionStorage.removeItem(`otp_sent_${this.applicationIdValue}`)

      // Reload the page to trigger new code send
      window.location.reload()

    } catch (error) {
      this.showError(error.message || "Failed to update email. Please try again.")
      this.resetButton()
    }
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove("hidden")
  }

  hideError() {
    this.errorMessageTarget.classList.add("hidden")
  }

  resetButton() {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.innerHTML = "Update & Send Code"
  }
}
